<template>
  <w-modal
    v-model="show"
    :title="$t('modals.event-add')"
    :submit-button="$t('buttons.save')"
    :close-button="$t('buttons.cancel')"
    :close-on-submit="false"
    :hideOnOverlay="false"
    :hideOnEsc="false"
    @submit="save()"
    @close="close()"
  >
    <div class="row">
      <div class="form-group col-xs-12 col-md-6">
        <w-select
          :model="$schema.minimalScheduleType"
          :values="types"
          :title="$t($schema.minimalScheduleType.$schema.title)"
        />
      </div>

      <div class="form-group col-xs-12 col-md-6">
        <form-datepicker :model="$schema.scheduleContainer.start" :title="$t('schema.schedule.startMinimal')" />
      </div>

      <div class="form-group col-xs-12 col-md-12">
        <w-input :model="$schema.scheduleContainer.name" :title="$t($schema.scheduleContainer.name.$schema.title)" />
      </div>

      <div v-if="$schema.price.$schema.fieldRequired" class="form-group col-xs-12 col-md-12">
        <w-input :model="$schema.price" :title="$t($schema.price.$schema.title)" />
      </div>

      <div class="form-group col-xs-12 col-md-12">
        <w-input
          :model="$schema.scheduleContainer.description"
          :title="$t($schema.scheduleContainer.description.$schema.title)"
        />
      </div>
    </div>
    <!-- Harmonogram składowy -->
    <minimal-schedule-form
      :schema="$schema.scheduleContainer.schedules.$items[0].$item"
      :date="date"
      :scheduleType="$schema.minimalScheduleType.$model"
    />
  </w-modal>
</template>

<script>
import moment from 'moment';

import { minimalModalMixin } from '@/mixins/minimalModal';
import schema from '@/schemas/minimalSchedule.schema';
import { MinimalScheduleType, MinimalScheduleTypeTranslation } from '@/enums/minimalScheduleType.enum';
import { ScheduleType } from '@/enums/scheduleType.enum';
import MinimalScheduleForm from '@/components/forms/MinimalScheduleForm';
import { Months } from '@/enums/month.enum';
import { Week } from '@/enums/week.enum';
import { MinimalScheduleFrequency } from '@/enums/minimalScheduleFrequency.enum';
import { TableName } from '../../enums/tableName.enum';

const emptyData = () => ({
  minimalScheduleType: MinimalScheduleType.TRENING,
  price: null,
  scheduleContainer: {
    name: '',
    description: '',
    start: '',
    end: '',
    entityId: '',
    entityType: '',
    schedules: [
      {
        name: '',
        description: '',
        start: '',
        end: '',
        frequencyType: MinimalScheduleFrequency.ONCE,
        type: ScheduleType.INCLUDE,
        order: 1,
        duration: null,
        frequency: 1,
        day: null,
        month: null,
        week: null,
        hour: null,
        minute: null
      }
    ]
  }
});

// @vuese
// Modal dodawania uproszczonych składek
// @group Components
export default {
  mixins: [minimalModalMixin(emptyData)],
  schema,
  data() {
    return {
      MinimalScheduleType
    };
  },
  props: {
    // Data
    date: {
      type: Date,
      required: true
    }
  },
  components: {
    MinimalScheduleForm
  },
  methods: {
    // @vuese
    // Resetuje pola
    resetData() {
      this.$schema.$setData(emptyData());
      this.$schema.$reset();
      this.$schema.scheduleContainer.$setData({
        start: moment(this.date).format('YYYY-MM-DD')
      });
    },
    // @vuese
    // Waliduje formularz
    save() {
      this.saveToSchedule();
      if (!this.$schema.$validateAll().length) {
        if (this.$schema.minimalScheduleType.$model === MinimalScheduleType.TRENING) {
          this.saveSchedule();
        } else {
          this.saveFee();
        }
      }
    },
    // @vuese
    // Zapisuje dane z harmonogramu składowego
    saveToSchedule() {
      this.$schema.scheduleContainer.schedules.$items[0].$item.$setData({
        name: this.$schema.scheduleContainer.name.$model,
        description: this.$schema.scheduleContainer.description.$model,
        start: this.$schema.scheduleContainer.start.$model
      });
      this.$schema.scheduleContainer.end.$model = this.$schema.scheduleContainer.schedules.$items[0].$item.end.$model;
    },
    // @vuese
    // Zapisuje harmonogram
    saveSchedule() {
      this.$schema.scheduleContainer.entityType.$model = TableName.Team;
      this.$schema.scheduleContainer.entityId.$model = this.teamId.toString();
      this.$store
        .dispatch(`schedule/add`, this.deepClone(this.model.scheduleContainer))
        .then(() => {
          this.$store.dispatch('notifySuccess', { title: 'messages.schedule.added' });
          this.close();
        })
        .catch(() => this.$store.dispatch('notifyError', { title: 'messages.schedule.addError' }));
    },
    // @vuese
    // Zapisuje składke
    saveFee() {
      this.$schema.scheduleContainer.entityType.$model = TableName.Fee;
      this.$store
        .dispatch(
          `fee/add`,
          this.deepClone({
            price: this.model.price,
            name: this.model.scheduleContainer.name
          })
        )
        .then(feeId => {
          this.$schema.scheduleContainer.entityId.$model = feeId.toString();
          this.$store.dispatch(`schedule/add`, this.deepClone(this.model.scheduleContainer));
        })
        .then(() => {
          this.$store.dispatch('notifySuccess', { title: 'messages.schedule.added' });
          this.close();
        })
        .catch(() => this.$store.dispatch('notifyError', { title: 'messages.schedule.addError' }));
    }
  },
  computed: {
    types() {
      return Object.keys(MinimalScheduleType).map(type => ({
        value: MinimalScheduleType[type],
        text: this.$t(MinimalScheduleTypeTranslation[MinimalScheduleType[type]])
      }));
    },
    teamId() {
      return this.$route.params.teamId;
    }
  }
};
</script>
